<template>
  <div class="custom-selection-edit-header">
    <div class="header-label font-bold">
      {{ name }}
    </div>|
    <div class="header-label font-bold">
      {{ 'general.date_start' | translate }}:
      <span>{{ startDate }}</span>
    </div>|
    <div class="header-label font-bold">
      {{ 'general.date_end' | translate }}:
      <span>{{ endDate }}</span>
    </div>
    <span class="filler" />
    <button-switch v-model="isOfferSelected">
      Offer
    </button-switch>
    <button-switch v-model="isStatisticsSelected">
      Statistics
    </button-switch>
  </div>
</template>

<script>
import timeFormat from '@/filters/timeFormat';
import ButtonSwitch from '@/components/controls/button/ButtonSwitch.vue';

export default {
  name: 'CustomSelectionEditHeader',
  components: { ButtonSwitch },
  props: {
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    const params = this.$route.params || {};
    return {
      startDate: timeFormat.customSelectionEdit(+params.startDate, 'YYYY-MM-DD HH:mm'),
      endDate: timeFormat.customSelectionEdit(+params.endDate, 'YYYY-MM-DD HH:mm'),
    };
  },
  computed: {
    isOfferSelected: {
      get() {
        return this.$store.state.prematch.customSelection.isSelected.offer;
      },
      set() {
        this.$store.dispatch('prematch/customSelection/updateSelectionOptions', {
          offer: !this.isOfferSelected,
        });
      },
    },
    isStatisticsSelected: {
      get() {
        return this.$store.state.prematch.customSelection.isSelected.statistics;
      },
      set() {
        this.$store.dispatch('prematch/customSelection/updateSelectionOptions', {
          statistics: !this.isStatisticsSelected,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/style/variables';

.custom-selection-edit-header {
  display: flex;
  align-items: center;
  height: 55px;
  padding: 0 20px;

  .button-switch-control {
    margin-right: 20px;
    &:last-child { margin-right: 0; }
  }
}

.header-label {
  padding: 0 10px;

  &:first-child {
    padding-left: 0;
  }

  & > span {
    font-weight: $font-weight-normal;
  }
}
</style>
